var Preferences = /** @class */ (function () {
    function Preferences() {
        this.newTalent = {
            app: false,
            email: false,
        };
        this.talentMoved = {
            app: false,
            email: false,
        };
        this.talentComment = {
            app: false,
            email: false,
        };
        this.inboundEmail = {
            app: false,
            email: false,
        };
        this.dailyDigest = false;
        this.autoWatch = false;
    }
    Preferences.prototype.fromArray = function (preferences) {
        var array = preferences.delivery;
        if (array.hasOwnProperty('new_talent')) {
            this.newTalent.app = !!array.new_talent.find(function (string) { return string === 'app'; });
            this.newTalent.email = !!array.new_talent.find(function (string) { return string === 'email'; });
        }
        if (array.hasOwnProperty('talent_moved')) {
            this.talentMoved.app = !!array.talent_moved.find(function (string) { return string === 'app'; });
            this.talentMoved.email = !!array.talent_moved.find(function (string) { return string === 'email'; });
        }
        if (array.hasOwnProperty('talent_comment')) {
            this.talentComment.app = !!array.talent_comment.find(function (string) { return string === 'app'; });
            this.talentComment.email = !!array.talent_comment.find(function (string) { return string === 'email'; });
        }
        if (array.hasOwnProperty('inbound_email')) {
            this.inboundEmail.app = !!array.inbound_email.find(function (string) { return string === 'app'; });
            this.inboundEmail.email = !!array.inbound_email.find(function (string) { return string === 'email'; });
        }
        this.dailyDigest = preferences.daily_digest;
        this.autoWatch = preferences.auto_watch;
        return this;
    };
    Preferences.prototype.toArray = function () {
        var array = {
            new_talent: [],
            talent_moved: [],
            talent_comment: [],
            inbound_email: [],
        };
        if (this.newTalent.app) {
            array.new_talent.push('app');
        }
        if (this.newTalent.email) {
            array.new_talent.push('email');
        }
        if (this.talentMoved.app) {
            array.talent_moved.push('app');
        }
        if (this.talentMoved.email) {
            array.talent_moved.push('email');
        }
        if (this.talentComment.app) {
            array.talent_comment.push('app');
        }
        if (this.talentComment.email) {
            array.talent_comment.push('email');
        }
        if (this.inboundEmail.app) {
            array.inbound_email.push('app');
        }
        if (this.inboundEmail.email) {
            array.inbound_email.push('email');
        }
        return {
            daily_digest: this.dailyDigest,
            delivery: array,
            auto_watch: this.autoWatch,
        };
    };
    return Preferences;
}());
export { Preferences };
